import { render, staticRenderFns } from "./EndingStep.vue?vue&type=template&id=4a06dd95&"
import script from "./EndingStep.vue?vue&type=script&lang=js&"
export * from "./EndingStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports